export default "__VITE_ASSET__CkawW4t6__"